import { isRecognizedTrashieHost, getConfig } from '../config/config';
import { ROUTE_REDEEM, ROUTE_REGISTER } from '../components/trashie/config/routes';

// Runs before anything else in index.js: traffic on unrecognized hostnames
// (legacy Closet Cash domains, raw firebase-hosting URLs) is bounced to the
// canonical Trashie app without ever mounting React. Legacy /redeem links keep
// their query string and land on /register.
const shouldRenderApp = isRecognizedTrashieHost();

if (!shouldRenderApp) {
  const { pathname, search } = window.location;
  window.location.replace(
    pathname.includes(ROUTE_REDEEM)
      ? `${getConfig('BASE_URL_TRASHIE')}${ROUTE_REGISTER}${search}`
      : `${getConfig('BASE_URL_TRASHIE')}`,
  );
}

export default shouldRenderApp;
